<template>
<div id="zero" 
    class="welcome d-flex justify-content-center flex-column " 
    style="z-index: 0; height:100vh; min-height:500px; background-size:cover; background-image:url(/static/7777-Landing.jpg);"
    :style="{ 'background-image': 'url(/static/7777-Landing.jpg)'}">
    <div class="container-fluid text-center" style="z-index: 2;">
        <b-jumbotron header="Click 2 Date" lead="Ein Service der Ipro GmbH" >
            <p>Super Sache!</p>
        </b-jumbotron>
        <p></p>
    </div>
  
</div> 
</template>


<script>
export default {
  name: "IntroView",
  data() {
    return {
    };
  },
  methods: {
    onLoad: function() 
    {

    }
  },
  beforeMount() {
    this.onLoad();
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

#LandingText
{
  text-align: left;
  margin-left: 15px;
}

#LandingMessage
{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeView.vue